import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const filtersDirectoryRoute: InvariantJiraRoute = {
	name: 'filters-directory',
	path: '/jira/filters',
};
